export default "__VITE_ASSET__47065d40__"